/* eslint-disable import/prefer-default-export */
import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getTaskResponses = async (page, limit) => {
  try {
    const { data } = await axios.get(`/api/task-responses/?page=${page}&limit=${limit}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getTaskResponsesTeleaudit = async (
  page,
  limit,
  surveyResponseId,
  surveyTitle,
  location,
  email,
  dateStart,
  dateEnd,
  state,
  type,
) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    params.append('surveyResponseId', surveyResponseId);
    params.append('surveyTitle', surveyTitle);
    params.append('location', location);
    params.append('email', email);
    params.append('dateStart', dateStart);
    params.append('dateEnd', dateEnd);
    params.append('state', state);
    params.append('type', type);
    const url = `/api/task-responses/teleaudit/?${params.toString()}`;
    const { data } = await axios.get(url);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

export {
  getTaskResponses,
  getTaskResponsesTeleaudit,
};
